module.exports = __webpack_public_path__ + "static/media/booth-top.89eaa412.png";